import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ClearIcon from '@material-ui/icons/Clear';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import ActionText from '../../core/ActionText';
import CancelButton from '../../core/CancelButton';
import Datatype from '../../core/Datatype';
import LabelledSwitch from '../../core/LabelledSwitch';
import MenuSelector from '../../core/MenuSelector';
import PrimaryAddButton from '../../core/PrimaryAddButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import TitledTextField from '../../core/TitledTextField';
import { DATATYPES, MAX_DEFINITION_LENGTH } from '../../core/utils/constants';
import { checkValidity, displayDate, getGraphFromProject, getProjectFromGraph, isRTL, sanitiseText } from '../../core/utils/utils';
import FindOntologyRelatedResource from '../taxonomies/FindOntologyRelatedResource';
import CommonIriDisplay from '../../application-core/CommonIriDisplay';
import { DOES_NOT_HAVE_PROPERTY, DOES_NOT_HAVE_PROPERTY_WITH_VALUE, HAS_PROPERTY, HAS_PROPERTY_WITH_VALUE } from './constants';
import AccessibleTooltip from '../../core/AccessibleTooltip';

class AddFilterDialog extends React.Component {

    constructor(props) {
        super(props);
        let range = null;
        if (props.data.range && props.data.range !== "" && props.data.range !== undefined) {
            range = props.data.range;
        }
        else {
            if (props.data.format !== "relation") {
                range = DATATYPES.STRING;
            }
        }
        // If no classes certain options should not be available
        const selectFromDisabled = props.data.format === "class" && props.classList.length === 0 ?
            true
            :
            false;
        this.state = {
            open: false,
            filterType: selectFromDisabled ? HAS_PROPERTY : HAS_PROPERTY_WITH_VALUE,
            selectFromDisabled,
            range,
            invalidValue: false,
            valueKey: 0,
            text: "",
            targetProjectGraph: props.graph,
            targetProjectType: props.projectType,
            date: Date.now(),
            checked: false,
            isExactMatch: false,
            value: props.data.range === DATATYPES.BOOLEAN ? ['false'] : []
        };
    }

    addFilter = () => {
        this.props.onAddFilter(this.props.data.value, this.state.filterType, this.state.value, this.state.isExactMatch, this.state.targetProjectGraph);
        this.exitAddFilter();
    };

    selectValue = (value) => {
        const newValues = [value, ...this.state.value];
        this.setState({ value: newValues });
    };

    selectLiteralValue = () => {
        this.selectValue(this.state.text);
        this.setState({ text: "" });
    };

    exitAddFilter = () => this.props.onExitAddFilter();

    handleTypeChange = (ev) => {
        const filterType = ev.target.value;
        this.setState({
            filterType,
            checked: false,
            invalidValue: false,
            value: this.props.data.range === DATATYPES.BOOLEAN && (filterType === HAS_PROPERTY_WITH_VALUE || filterType === DOES_NOT_HAVE_PROPERTY_WITH_VALUE) ?
                ['false']
                :
                [],
            text: "",
            isExactMatch: false
        });
    };

    handleExactMatchChange = (ev) => {
        const isExactMatch = ev.target.checked;
        this.setState({ isExactMatch });
    };

    updateSearchText = (text) => this.setState({ text });

    checkLiteralValidity() {
        const { text } = this.state;
        if (text.trim() === "") {
            this.setState({ error: false });
            return;
        }
        let validity = checkValidity(text.trim(), this.state.range, [], MAX_DEFINITION_LENGTH);
        this.setState({ error: !validity.isValid });
    }

    computeDate = (tempDate) => {
        return tempDate.getFullYear() + "-" +
            ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-" +
            ("0" + tempDate.getDate()).slice(-2);

    };

    handleDateChange = (data) => {
        if (data === null) {
            this.setState({ invalidValue: true, date: data });
            return;
        }
        const tempDate = new Date(data);
        if (tempDate.toString() === "Invalid Date") {
            this.setState({ invalidValue: true, date: data });
            return;
        }
        const customValue = this.computeDate(tempDate);
        const invalidValue = this.state.value.includes(customValue);
        this.setState({
            invalidValue,
            date: data,
        });
    };

    addDateValue = () => {
        const tempDate = new Date(this.state.date);
        const customValue = this.computeDate(tempDate);
        this.setState({ invalidValue: true }, () => this.selectValue(customValue));
    };

    handleBooleanChange = (checked) => {
        this.setState({
            checked,
            value: [checked ? 'true' : 'false']
        });
    };

    handleLiteralChange = (event) => {
        const t = event.target;
        const cleanText = sanitiseText(t.value.trimLeft());
        const invalidValue = cleanText.trim() === "";
        this.setState({
            text: cleanText,
            invalidValue
        }, this.checkLiteralValidity);
    };

    changeTargetProject = (targetProject, targetProjectType) => this.setState({
        value: [],
        valueKey: uuidv4(),
        targetProjectType,
        targetProjectGraph: getGraphFromProject(targetProject)
    });

    onRemoveValue = (value) => {
        const newValues = [...this.state.value].filter(v => v !== value);
        const invalidValue = newValues.length === 0 ? false : this.state.invalidValue;
        this.setState({ value: newValues, valueKey: uuidv4(), invalidValue });
    };

    render() {
        const { classes, defaultLang, data, project, components, classList, projectType, graph } = this.props;
        const { text, filterType, value, error, isExactMatch, checked, date, invalidValue, targetProjectGraph,
            range, valueKey, selectFromDisabled, targetProjectType } = this.state;

        const invalid = filterType === HAS_PROPERTY_WITH_VALUE || filterType === DOES_NOT_HAVE_PROPERTY_WITH_VALUE ?
            value.length === 0
            :
            false;

        const sortedValue = value ?
            [...value].sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1)
            :
            [];

        const exists = value.includes(text);
        const rtl = this.props.lang ? isRTL(this.props.lang) : false;

        let dataFindComponent;
        if (data.format === "datatype" || data.format === "langString") {
            switch (range) {
                case DATATYPES.DATE:
                    dataFindComponent = <TitledPanel
                        required={value.length === 0}
                        height="full"
                        title="Select a Date">
                        <div style={{ display: 'flex' }}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        className={classes.datepicker}
                                        data-test="date-picker"
                                        inputProps={{
                                            "data-test": "date-picker-text"
                                        }}
                                        format="yyyy/MM/dd"
                                        minDate={new Date("1001-01-01")}
                                        margin="dense"
                                        id="date-picker-inline"
                                        value={date}
                                        inputVariant="outlined"
                                        onChange={this.handleDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'Select date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div style={{ marginLeft: 12, marginTop: 12 }}>
                                <AccessibleTooltip title="Add to selected values" placement="bottom">
                                    <span>
                                        <IconButton
                                            data-test="add-date"
                                            disabled={invalidValue}
                                            onClick={this.addDateValue}
                                            className={classes.smallIconButton}
                                            size="small">
                                            <DoubleArrowIcon />
                                        </IconButton>
                                    </span>
                                </AccessibleTooltip>
                            </div>
                        </div>
                    </TitledPanel>;
                    break;
                case DATATYPES.LANGSTRING:
                    dataFindComponent =
                        <TitledTextField
                            dataTest="filter-text"
                            name="text"
                            height="full"
                            autoFocus={true}
                            title="Text"
                            lang={this.props.lang}
                            inlineLengthWarning={true}
                            error={error || exists}
                            errorText={
                                exists ?
                                    "This value already exists."
                                    :
                                    ""
                            }
                            placeholder="Please enter text"
                            required={value.length === 0}
                            text={text}
                            multiline={false}
                            rows={1}
                            minLength={2}
                            maxLength={100}
                            adornment={<AccessibleTooltip title="Add to selected values" placement="bottom">
                                <span>
                                    <IconButton
                                        disabled={text === "" || text.length < 2 || error || value.includes(text)}
                                        onClick={this.selectLiteralValue}
                                        className={classes.smallIconButton}
                                        size="small">
                                        <DoubleArrowIcon />
                                    </IconButton>
                                </span>
                            </AccessibleTooltip>}
                            onEnter={error || value.includes(text) ? null : this.selectLiteralValue}
                            onChange={this.handleLiteralChange} />;
                    break;
                case DATATYPES.BOOLEAN:
                    dataFindComponent =
                        <TitledPanel
                            required={true}
                            title="Select a Value">
                            <div style={{ display: 'flex' }}>
                                <Typography className={classes.formLabel} style={{ marginTop: 18 }}>False</Typography>
                                <LabelledSwitch
                                    dataTest="true-false"
                                    label="True"
                                    checked={checked}
                                    handleChange={this.handleBooleanChange}
                                />
                            </div>
                        </TitledPanel>;
                    break;
                case DATATYPES.STRING: case DATATYPES.ANYURI: case DATATYPES.INTEGER: case DATATYPES.NNINTEGER: case DATATYPES.DECIMAL: case DATATYPES.FLOAT: case DATATYPES.DOUBLE: case DATATYPES.LONG:
                    dataFindComponent = <TitledTextField
                        height="full"
                        dataTest="typed-literal-input"
                        name="literal"
                        title="Text"
                        autoFocus={true}
                        lang={data.format === "langString" ? this.props.lang : null}
                        inlineLengthWarning={true}
                        required={value.length === 0}
                        placeholder="Please enter text"
                        error={error || exists}
                        text={text}
                        startAdornment={<Datatype datatype={range} />}
                        errorText={
                            error ?
                                "The value is not valid for the range."
                                :
                                exists ?
                                    "This value already exists."
                                    :
                                    ""
                        }
                        minLength={range === DATATYPES.INTEGER || range === DATATYPES.NNINTEGER ? 1 : 2}
                        maxLength={100}
                        adornment={<AccessibleTooltip title="Add to selected values" placement="bottom">
                            <span>
                                <IconButton
                                    aria-label="Add value"
                                    data-test="add-value-icon"
                                    disabled={text === ""
                                        || (range !== DATATYPES.INTEGER && range !== DATATYPES.NNINTEGER && text.length < 2)
                                        || error || value.includes(text)}
                                    onClick={this.selectLiteralValue}
                                    className={classes.smallIconButton}
                                    size="small">
                                    <DoubleArrowIcon />
                                </IconButton>
                            </span>
                        </AccessibleTooltip>}
                        onEnter={error || value.includes(text) ? null : this.selectLiteralValue}
                        onChange={this.handleLiteralChange} />;
                    break;
                default:
                    break;
            }
        }

        return (
            <Dialog
                data-test="add-filter-dialog"
                maxWidth="lg"
                fullWidth
                classes={{
                    paper: classes.paper,
                    paperWidthLg: classes.largeDialog
                }}
                className={classes.dialog}
                open={true}
                onClose={this.exitAddFilter}
                aria-labelledby="find-concept-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} id="find-concept-dialog-title">Add Filter for {data.label}</DialogTitle>
                <DialogContent style={{ height: 520 }}>
                    <TitledPanel dataTest="filter-type" title="Filter Type">
                        <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                            <legend className={classes.hideLegend}>Filter type</legend>
                            <RadioGroup
                                row
                                aria-label="Filter Type"
                                name="filterType"
                                value={filterType}
                                onChange={this.handleTypeChange}>
                                <Grid container>
                                    <Grid item xs={5}>
                                        <FormControlLabel data-test="select-hp"
                                            value={HAS_PROPERTY}
                                            control={<Radio color="primary" />}
                                            label="Has Property (With any Value)"
                                            classes={{ label: classes.formLabelInline }}
                                        />
                                    </Grid>
                                    <Grid item xs={7}>
                                        <FormControlLabel data-test="select-hpv"
                                            value={HAS_PROPERTY_WITH_VALUE}
                                            disabled={selectFromDisabled}
                                            control={<Radio color="primary" />}
                                            label="Has Property With One or More Values From"
                                            classes={{ label: classes.formLabelInline }}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <FormControlLabel data-test="select-dnhp"
                                            value={DOES_NOT_HAVE_PROPERTY}
                                            control={<Radio color="primary" />}
                                            label="Does not Have Property"
                                            classes={{ label: classes.formLabelInline }}
                                        />
                                    </Grid>
                                    <Grid item xs={7}>
                                        <FormControlLabel data-test="select-dnhpv"
                                            value={DOES_NOT_HAVE_PROPERTY_WITH_VALUE}
                                            disabled={selectFromDisabled}
                                            control={<Radio color="primary" />}
                                            label="Does not Have Property With Specific Values"
                                            classes={{ label: classes.formLabelInline }}
                                        />
                                    </Grid>
                                </Grid>
                            </RadioGroup>
                        </FormControl>
                    </TitledPanel>
                    {data.format === "relation" && (filterType === HAS_PROPERTY_WITH_VALUE || filterType === DOES_NOT_HAVE_PROPERTY_WITH_VALUE) &&
                        <div style={{ marginTop: 12, height: 370 }}>
                            <Grid container style={{ height: '100%' }}>
                                <Grid item xs={6}>
                                    <TitledPanel
                                        height="full"
                                        required={value.length === 0}
                                        dataTest="find-values"
                                        title={value.length === 5 ? "Filter Value Limit Reached" : "Find Values"}>
                                        <div style={{ backgroundColor: value.length === 5 ? 'inherit' : 'white', padding: 6, borderRadius: 4, marginBottom: 4 }}>
                                            {value && value.length === 5 ?
                                                <Typography data-test="max-values" variant="body2">A maximum of five filter values is permitted.</Typography>
                                                :
                                                <FindOntologyRelatedResource
                                                    searchClasses={!range ? [] : [range]}
                                                    allowIRI={false}
                                                    key={valueKey}
                                                    enableProjectSelection={data.enableProjectSelection === false ? false : true}
                                                    customPropertyGraph={data.graph}
                                                    project={getProjectFromGraph(targetProjectGraph)}
                                                    projectType={projectType}
                                                    targetProjectType={targetProjectType}
                                                    graph={targetProjectGraph}
                                                    singleValue={false}
                                                    exclude={value}
                                                    height={304}
                                                    selectedStyle={{
                                                        backgroundColor: 'white',
                                                        opacity: 1,
                                                        border: 'solid 1px black',
                                                        borderRadius: '4px'
                                                    }}
                                                    onChangeProject={this.changeTargetProject}
                                                    onIncludeResource={this.selectValue}
                                                    allowEmpty={range && range !== ""} />
                                            }
                                        </div>
                                    </TitledPanel>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ marginLeft: 12, height: '100%' }}>
                                        <TitledPanel height="full" dataTest="values" title="Selected Values">
                                            {value.length === 0 &&
                                                <div style={{ height: '120px' }}>
                                                    <ActionText offset="70px">Add values by searching.</ActionText>
                                                </div>
                                            }
                                            <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                                                {
                                                    [...value].sort().map(v => <CommonIriDisplay
                                                        key={v}
                                                        id={v}
                                                        projectType={projectType}
                                                        showProject={graph !== targetProjectGraph}
                                                        onDeleteIRI={this.onRemoveValue}
                                                        components={graph !== targetProjectGraph ? undefined : components}
                                                        loadComponents={graph !== targetProjectGraph}
                                                        projectIRI={graph !== targetProjectGraph ? getProjectFromGraph(targetProjectGraph) : project}
                                                        handleNotAvailable={true}
                                                        graph={targetProjectGraph}
                                                        sourceGraph={graph}
                                                        viewLang={defaultLang}
                                                        defaultLang={defaultLang} />
                                                    )
                                                }
                                            </div>
                                        </TitledPanel>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    }
                    {data.format === "class" && (filterType === HAS_PROPERTY_WITH_VALUE || filterType === DOES_NOT_HAVE_PROPERTY_WITH_VALUE) &&
                        <div style={{ marginTop: 12, height: 340 }}>
                            <Grid container style={{ height: '100%' }}>
                                <Grid item xs={6}>
                                    <TitledPanel
                                        height="full"
                                        required={value.length === 0}
                                        dataTest="find-values"
                                        title={value.length === 5 ? "Filter Value Limit Reached" : "Find Values"}>
                                        {value && value.length === 5 ?
                                            <Typography data-test="max-values" variant="body2">A maximum of five filter values is permitted.</Typography>
                                            :
                                            <div style={{ height: 40, overflow: 'visible' }}>
                                                <MenuSelector
                                                    key={value.length}
                                                    dataTest="class-selector"
                                                    showValues={true}
                                                    selected={""}
                                                    handleChange={this.selectValue}
                                                    options={classList.filter(c => !value.includes(c.value))} />
                                            </div>
                                        }
                                    </TitledPanel>
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ marginLeft: 12, height: '100%' }}>
                                        <TitledPanel height="full" dataTest="values" title="Selected Values">
                                            {value.length === 0 &&
                                                <ActionText offset="70px">Select classes from the<br />list on the left.</ActionText>
                                            }
                                            {[...value].sort().map(v => {
                                                const valueGraph = classList.find(c => c.value === v).graph;
                                                return <CommonIriDisplay
                                                    key={"rel-" + v}
                                                    id={v}
                                                    projectIRI={getProjectFromGraph(valueGraph)}
                                                    loadComponents={true}
                                                    compact={true}
                                                    handleNotAvailable={true}
                                                    isReadOnly={false}
                                                    onDeleteIRI={this.onRemoveValue}
                                                    wrap={false}
                                                    graph={valueGraph}
                                                    viewLang={defaultLang}
                                                    defaultLang={defaultLang} />;
                                            })}
                                        </TitledPanel>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    }
                    {(data.format === "datatype" || data.format === "langString") && (filterType === HAS_PROPERTY_WITH_VALUE || filterType === DOES_NOT_HAVE_PROPERTY_WITH_VALUE) &&
                        <div style={{ marginTop: 12, height: 340 }}>
                            <Grid container style={{ height: '100%' }}>
                                <Grid item xs={6}>
                                    {value && value.length === 5 ?
                                        <TitledPanel
                                            height="full"
                                            title="Filter Value Limit Reached">
                                            <Typography data-test="max-values" variant="body2">A maximum of five filter values is permitted.</Typography>
                                        </TitledPanel>
                                        :
                                        dataFindComponent
                                    }
                                </Grid>
                                <Grid item xs={6}>
                                    <div style={{ marginLeft: 12, height: '100%' }}>
                                        <TitledPanel height="full" dataTest="values" title="Selected Values">
                                            {value.length === 0 &&
                                                <ActionText offset="70px">Add values on the left.</ActionText>
                                            }
                                            {value.length !== 0 &&
                                                <div>
                                                    {range !== DATATYPES.BOOLEAN && range !== DATATYPES.DATE &&
                                                        <div style={{ marginLeft: '4px' }}>
                                                            <FormControlLabel
                                                                data-test="exact-match"
                                                                control={
                                                                    <Checkbox data-test="exact-match-box" checked={isExactMatch} onChange={this.handleExactMatchChange} name="isExactMatch" />}
                                                                label="Exact Match"
                                                                classes={{ label: classes.formLabelInline }}
                                                            />
                                                        </div>
                                                    }
                                                    {
                                                        sortedValue.map((v, index) =>
                                                            <div
                                                                key={index}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    border: 'solid 1px #c0c0c0',
                                                                    borderRadius: 4,
                                                                    marginBottom: 6,
                                                                    backgroundColor: 'white',
                                                                    padding: 6
                                                                }}>
                                                                <div
                                                                    data-test={"text-value-" + index}
                                                                    style={{
                                                                        flex: 1,
                                                                        wordWrap: 'break-word',
                                                                        marginTop: 4,
                                                                        maxWidth: 'calc(100% - 40px)'
                                                                    }}
                                                                    key={index}>
                                                                    <Typography
                                                                        dir={data.format === "langString" && rtl ? "rtl" : null}
                                                                        variant="body2">
                                                                        {range === DATATYPES.DATE ?
                                                                            displayDate(v)
                                                                            :
                                                                            range === DATATYPES.BOOLEAN ?
                                                                                v.toUpperCase()
                                                                                :
                                                                                v
                                                                        }
                                                                    </Typography>
                                                                </div>
                                                                {range !== DATATYPES.BOOLEAN &&
                                                                    <div style={{
                                                                        flex: 0,
                                                                        width: 40,
                                                                        textAlign: 'right',
                                                                        marginLeft: 6
                                                                    }}>
                                                                        <AccessibleTooltip title="Remove value">
                                                                            <IconButton data-test={"remove-value-" + index}
                                                                                className={classes.smallIconButton}
                                                                                size="small"
                                                                                onClick={() => this.onRemoveValue(v)}>
                                                                                <ClearIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </AccessibleTooltip>
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            }
                                        </TitledPanel>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    }
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <CancelButton onClick={this.exitAddFilter} />
                    <PrimaryAddButton title="Add filter" disabled={invalid} onClick={this.addFilter} />
                </DialogActions>
            </Dialog>
        );
    }
}

AddFilterDialog.defaultProps = {
    exclude: [],
    searchClasses: [],
    skosXL: false,
    allowIRI: false,
    classList: []
};

AddFilterDialog.propTypes = {
    searchClasses: PropTypes.array,
    graph: PropTypes.string.isRequired,
    allowIRI: PropTypes.bool,
    lang: PropTypes.string,
    classList: PropTypes.array,
    data: PropTypes.object.isRequired,
    project: PropTypes.string.isRequired,
    skosXL: PropTypes.bool,
    projectType: PropTypes.string.isRequired,
    components: PropTypes.array,
    ontologyProjectAssociation: PropTypes.array,
    defaultLang: PropTypes.string.isRequired,
    onExitAddFilter: PropTypes.func.isRequired,
    onAddFilter: PropTypes.func.isRequired,
    exclude: PropTypes.array,
    classes: PropTypes.object
};

export default withStyles(styles)(AddFilterDialog);